import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ButtonColor, ButtonShape, ButtonSize, GridView } from '../../enums';
import { ListViewIcon, TileViewIcon } from '../Icons';
import { SelectButton } from '../SelectButton';
const GridSwitcher = ({ a11yListViewText, a11yTileViewText, className, dataTestId, defaultView = GridView.ListView, listViewText, onSwitch, tileViewText, }) => {
    const gridSwitcherConfig = useMemo(() => ({
        color: ButtonColor.BrandDark,
        size: ButtonSize.Small,
        shape: ButtonShape.Rounded,
        options: [
            {
                value: GridView.ListView,
                text: listViewText,
                icon: ListViewIcon,
                a11yText: a11yListViewText,
            },
            {
                value: GridView.TileView,
                text: tileViewText,
                icon: TileViewIcon,
                a11yText: a11yTileViewText,
            },
        ],
    }), [a11yListViewText, a11yTileViewText, listViewText, tileViewText]);
    return (_jsx(SelectButton, { ...gridSwitcherConfig, onChange: onSwitch, className: className, defaultSelected: defaultView, "data-testid": dataTestId }));
};
export { GridSwitcher };
